import axios from 'axios'

const MAX_SERVER_MESSAGE_LENGTH = 500

/**
 * Extracts a human-readable message from a failed request's server response body, when one is
 * present. Portfolio Manager's 400 bodies are informative, e.g. "The bid includes an update for a
 * PTU that is not biddable anymore (2026-03-11T10:00Z: 10000000 -> 11000000 WATTS)", so surfacing
 * that text in the alert saves a support round-trip that a generic error message would otherwise cause.
 *
 * Returns undefined when `error` is not an Axios error, or its response body carries no usable
 * string message (a plain string body, or a `message`/`detail` field on an object body).
 */
export function extractServerErrorMessage(error: unknown): string | undefined {
  if (!axios.isAxiosError(error)) {
    return undefined
  }

  const data: unknown = error.response?.data
  const message = typeof data === 'string' ? data : extractStringMessageField(data)

  if (typeof message !== 'string' || message.trim().length === 0) {
    return undefined
  }

  return message.length > MAX_SERVER_MESSAGE_LENGTH ? `${message.slice(0, MAX_SERVER_MESSAGE_LENGTH)}…` : message
}

function extractStringMessageField(data: unknown): unknown {
  if (typeof data !== 'object' || data === null) {
    return undefined
  }

  const { message, detail } = data as { message?: unknown; detail?: unknown }
  return message ?? detail
}
